module.exports = __webpack_public_path__ + "img/DE00049.119fa7a4.png";